<template>
  <div id="app">
    <video
      autoplay
      muted
      loop
      playsinline
      id="bg-video"
      :style="bgVideoStyle"
      @loadedmetadata="mx3ApplyVideoSpeed"
      @play="mx3ApplyVideoSpeed"
      v-if="$route.name == 'Home' || $route.path.includes('products')"
    >
      <source :src="bgVideoSrc" :type="bgVideoType" />
    </video>
    <Header class="hide-on-mobile" v-if="!isAuthPage" />
    <HeaderMobile class="show-on-mobile" v-if="!isAuthPage" />
    <main>
      <!-- {{ $store.state.imagensDeProduto }} -->
      <div class="container" v-if="false">
        <div class="p-2">
          {{ pageName }}
        </div>
      </div>
      <div class="col">
        <router-view />
      </div>
    </main>
    <ConsentimentoCookies />
    <InstitutionalPageSyncButton />
    <Footer v-if="!isAuthPage" />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import HeaderMobile from "@/components/HeaderMobile.vue";
import Footer from "@/components/Footer.vue";
import ConsentimentoCookies from "@/components/ConsentimentoCookies.vue";
import InstitutionalPageSyncButton from "@/components/InstitutionalPageSyncButton.vue";
import { getPublicApiConfig } from "@/services/apiConfig.js";
import { definirUF, ufDoCliente } from "@/services/tensao";

export default {
  name: "App",
  components: {
    Header,
    HeaderMobile,
    ConsentimentoCookies,
    Footer,
    InstitutionalPageSyncButton,
  },
  data() {
    return {
      psw: localStorage.getItem("psw"),
      baseUrl: process.env.BASE_URL,
      // Tema atual, usado para escolher a versão correta (clara/escura)
      // do vídeo de fundo do banner. Mesma fonte de verdade do
      // ThemeSwitcher (localStorage 'siteTheme').
      isDarkTheme: (() => {
        const previewTheme = new URLSearchParams(window.location.search).get('mx3_preview_theme');
        return previewTheme ? previewTheme !== 'light' : localStorage.getItem("siteTheme") !== "light";
      })(),
      // "Modo Edição" da tela Personalizar (Gerenciador de Produtos) -
      // ver onMx3ThemeEditModeMessage()/mx3SetEditModeActive() abaixo.
      mx3EditModeActive: false,
      mx3LogoMoveActive: false,
      mx3LogoSelectActive: false,
      // Vídeo de banner personalizado por tema (tela Personalizar > Vídeo
      // do Banner). "" = usa o vídeo padrão. mx3PreviewVideoOverride tem
      // prioridade quando estamos dentro do iframe de pré-visualização
      // (troca em tempo real, antes mesmo de publicar - ver
      // onMx3ThemePreviewMessage abaixo).
      mx3CustomVideoUrl: {
        dark: (window.MX3_THEME_MEDIA && window.MX3_THEME_MEDIA.dark && window.MX3_THEME_MEDIA.dark.videoUrl) || "",
        light: (window.MX3_THEME_MEDIA && window.MX3_THEME_MEDIA.light && window.MX3_THEME_MEDIA.light.videoUrl) || "",
      },
      mx3PreviewVideoOverride: null,
      // Zoom do vídeo do banner por tema (tela Personalizar > Vídeo do
      // Banner, em % da largura da tela; 100 = vídeo ajustado à tela,
      // 500 = visual original). Vazio/inválido = mantém o CSS do tema.
      // mx3PreviewVideoZoom tem prioridade na pré-visualização do
      // Gerenciador ({ tema, zoom }; zoom null = volta ao padrão do CSS).
      mx3CustomVideoZoom: {
        dark: (window.MX3_THEME_MEDIA && window.MX3_THEME_MEDIA.dark && window.MX3_THEME_MEDIA.dark.zoom) || null,
        light: (window.MX3_THEME_MEDIA && window.MX3_THEME_MEDIA.light && window.MX3_THEME_MEDIA.light.zoom) || null,
      },
      mx3PreviewVideoZoom: null,
      // Velocidade do vídeo do banner por tema (tela Personalizar, em % da
      // velocidade normal: 100 = original, menor = mais lento). Vazio/inválido
      // = velocidade normal. mx3PreviewVideoSpeed tem prioridade na
      // pré-visualização do Gerenciador ({ tema, speed }).
      mx3CustomVideoSpeed: {
        dark: (window.MX3_THEME_MEDIA && window.MX3_THEME_MEDIA.dark && window.MX3_THEME_MEDIA.dark.speed) || null,
        light: (window.MX3_THEME_MEDIA && window.MX3_THEME_MEDIA.light && window.MX3_THEME_MEDIA.light.speed) || null,
      },
      mx3PreviewVideoSpeed: null,
      // Evita que o watcher profundo salve [] enquanto a lista da conta
      // ainda está sendo recuperada do servidor.
      restaurandoDesejosDaConta: false,
    };
  },
  mounted() {
    let psw = localStorage.getItem("psw");
    if (!psw) {
      //this.$router.push({ name: "password" });
    }
    // Mantém o vídeo de fundo sincronizado quando o tema é alternado
    // (ThemeSwitcher emite este evento em toggleTheme()/onExternalThemeChange()).
    this.$root.$on("mx3-theme-changed", this.onThemeChangedForVideo);

    // Pré-visualização em tempo real da tela "Personalizar" (Gerenciador
    // de Produtos): quando este site é aberto dentro do iframe dessa
    // tela, o gerenciador tentava escrever diretamente no
    // <style id="mx3-preview-override"> via iframe.contentDocument. Isso
    // só funciona quando os dois estão na mesma origem - mas, na
    // configuração real (Gerenciador e E-commerce em domínios
    // diferentes, ver paths_config_manager.php), o navegador bloqueia
    // esse acesso entre origens (erro silencioso), e as cores em edição
    // nunca apareciam na pré-visualização. postMessage funciona entre
    // origens diferentes sem exigir nenhuma configuração extra, então o
    // e-commerce passa a aplicar a sobreposição de cores recebida por
    // essa via (além de continuar aceitando a escrita direta, quando a
    // origem coincidir).
    window.addEventListener("message", this.onMx3ThemePreviewMessage);
    // "Modo Edição" da tela Personalizar: liga/desliga a captura de
    // clique em elementos desta página quando o Gerenciador pede (ver
    // onMx3ThemeEditModeMessage abaixo).
    window.addEventListener("message", this.onMx3ThemeEditModeMessage);
    // Mapa de Elementos da tela Personalizar: "localizar/destacar" uma área
    // do site e "selecionar o elemento pai" do item atual do Modo Edição.
    window.addEventListener("message", this.onMx3ThemeLocateMessage);
    window.addEventListener("message", this.onMx3LogoMessage);
  },
  beforeDestroy() {
    this.$root.$off("mx3-theme-changed", this.onThemeChangedForVideo);
    window.removeEventListener("message", this.onMx3ThemePreviewMessage);
    window.removeEventListener("message", this.onMx3ThemeEditModeMessage);
    window.removeEventListener("message", this.onMx3ThemeLocateMessage);
    window.removeEventListener("message", this.onMx3LogoMessage);
    this.mx3SetLogoSelectActive(false);
    this.mx3SetLogoMoveActive(false);
    this.mx3SetEditModeActive(false);
  },
  computed: {
    bgVideoSrc() {
      const tema = this.isDarkTheme ? "dark" : "light";
      // Prioridade: 1) troca em tempo real vinda do Modo Edição/preview
      // do Gerenciador (ainda não publicada); 2) vídeo já publicado para
      // este tema (theme-media-config.js); 3) vídeo padrão do e-commerce.
      if (this.mx3PreviewVideoOverride && this.mx3PreviewVideoOverride.tema === tema) {
        return this.mx3PreviewVideoOverride.url || this.mx3DefaultVideoUrl(tema);
      }
      const customUrl = this.mx3CustomVideoUrl[tema];
      return customUrl || this.mx3DefaultVideoUrl(tema);
    },
    // Zoom do vídeo de fundo = zoom% do enquadramento "cover" da tela (100 =
    // vídeo preenchendo a tela, sem ampliar). Usa transform: scale a partir da
    // borda esquerda / meio da altura (mesmo enquadramento do visual original),
    // então funciona igual em computador, tablet e celular (em tela "em pé" a
    // altura é que define o enquadramento, e mudar só a largura não ampliava).
    // Sem zoom configurado não define nada e vale o CSS do tema
    // (#bg-video em main.css/main-light.css).
    bgVideoStyle() {
      const tema = this.isDarkTheme ? "dark" : "light";
      let zoom = this.mx3CustomVideoZoom[tema];
      if (this.mx3PreviewVideoZoom && this.mx3PreviewVideoZoom.tema === tema) {
        zoom = this.mx3PreviewVideoZoom.zoom;
      }
      zoom = Number(zoom);
      if (!isFinite(zoom) || zoom < 100 || zoom > 800) return {};
      return {
        width: "100vw",
        height: "100vh",
        transform: "scale(" + zoom / 100 + ")",
        transformOrigin: "0 50%",
      };
    },
    // Taxa de reprodução do vídeo (1 = normal) do tema atual; 1 se não configurada.
    bgVideoRate() {
      const tema = this.isDarkTheme ? "dark" : "light";
      let speed = this.mx3CustomVideoSpeed[tema];
      if (this.mx3PreviewVideoSpeed && this.mx3PreviewVideoSpeed.tema === tema) {
        speed = this.mx3PreviewVideoSpeed.speed;
      }
      speed = Number(speed);
      if (!isFinite(speed) || speed < 10 || speed > 400) return 1;
      return speed / 100;
    },
    bgVideoType() {
      // O <source> declara o MIME certo pro arquivo atual - os vídeos
      // padrão são .webm, mas um vídeo enviado pela tela Personalizar
      // pode ser .mp4, e o navegador ignora o <source> se o "type"
      // declarado não bater com o arquivo de verdade.
      const src = this.bgVideoSrc || "";
      return src.toLowerCase().endsWith(".mp4") ? "video/mp4" : "video/webm";
    },
    isAuthPage() {
      return ["/login", "/register", "/recovery"].includes(this.$route.path);
    },
    pageName() {
      if (this.$route.meta.isLogin) {
        return null;
      }
      let title = this.$route?.meta?.title ?? "";
      return title ? `Início / ${title}` : "";
    },
  },
  watch: {
    // Reaplica a velocidade quando muda (pré-visualização ao vivo ou troca de tema).
    bgVideoRate() {
      this.$nextTick(() => this.mx3ApplyVideoSpeed());
    },
    "$store.state.carrinho"(v) {
      localStorage.setItem(
        "itensCarrinho",
        JSON.stringify(this.$store.state.carrinho)
      );
      // Mantém o carrinho salvo vinculado à conta do cliente logado, para
      // que ele possa ser recuperado em um novo login (ver logout() em
      // AccountMenu.vue e restaurarCarrinhoDaConta() abaixo).
      if (localStorage.getItem("accessToken")) {
        this.$api
          .httpService()
          .post(window.location.origin + "/api/cart_save.php", {
            itens: this.$store.state.carrinho,
          })
          .catch((err) => console.error("Erro ao salvar carrinho da conta:", err));
      }
    },
    "$store.state.desejos": {
      deep: true,
      handler() {
      // A lista de desejos pertence à conta autenticada. Não gravamos
      // favoritos em localStorage para impedir que eles apareçam em outra
      // conta ou após o logout.
      if (localStorage.getItem("accessToken") && !this.restaurandoDesejosDaConta) {
        this.salvarDesejosDaConta();
      }
      },
    },
  },
  created() {
    let carrinho = localStorage.getItem("itensCarrinho");
    if (carrinho) {
      this.$store.state.carrinho = JSON.parse(carrinho);
    }

    // Favoritos são sempre carregados do servidor da conta. Qualquer
    // vestígio local de versões anteriores é removido para não misturar
    // desejos entre usuários.
    localStorage.removeItem("itensDesejo");
    this.$store.state.desejos = [];

    // Carrega configurações do site do localStorage ou da API
    let configuracoes = localStorage.getItem("configuracoesSite");
    if (configuracoes) {
      this.$store.state.configuracoesSite = JSON.parse(configuracoes);
    }
    this.loadConfiguracoesSite();
    this.carregarResumoAvaliacoes();
    this.carregarCondicoesVenda();
    this.descobrirRegiaoDoCliente();

    if (localStorage.getItem("accessToken")) {
      if (!localStorage.getItem("carrinhoContaRestaurado")) {
        this.restaurarCarrinhoDaConta();
      }
      this.restaurarDesejosDaConta();
    }
  },
  methods: {
    // Descobre o estado (UF) do cliente para definir a tensão padrão (110V/220V) dos produtos que
    // existem nas duas tensões (services/tensao.js). Ordem: UF já guardada > endereço do cadastro
    // (cliente logado) > último CEP consultado (ViaCEP). Falhas são ignoradas: sem região, vale a
    // tensão principal do cadastro do produto.
    descobrirRegiaoDoCliente() {
      if (ufDoCliente()) return;
      const porCep = () => {
        const cep = String(localStorage.getItem("lastCep") || "").replace(/\D/g, "");
        if (cep.length !== 8) return;
        fetch("https://viacep.com.br/ws/" + cep + "/json/")
          .then((r) => r.json())
          .then((e) => { if (e && e.uf) definirUF(e.uf); })
          .catch(() => {});
      };
      if (localStorage.getItem("accessToken")) {
        this.$api
          .get(window.location.origin + "/api/cliente_address.php")
          .then((res) => {
            if (res && res.data && res.data.estado) definirUF(res.data.estado);
            if (!ufDoCliente()) porCep();
          })
          .catch(() => porCep());
      } else {
        porCep();
      }
    },
    // Atualiza a fonte do vídeo de fundo quando o tema é alternado e
    // força o elemento <video> a recarregar (mudar apenas o :src do
    // <source> não recarrega o vídeo automaticamente).
    onThemeChangedForVideo(isDark) {
      if (this.isDarkTheme === isDark) return;
      this.isDarkTheme = isDark;
      this.$nextTick(() => {
        const video = document.getElementById("bg-video");
        if (video) {
          video.load();
          video.play().catch(() => {});
        }
      });
    },
    // Aplica (ou remove) a folha de sobreposição de cores enviada pela
    // tela "Personalizar" do Gerenciador de Produtos, quando este site
    // está sendo exibido dentro do iframe de pré-visualização daquela
    // tela. Ver comentário em mounted() sobre por que isso usa
    // postMessage em vez de acesso direto ao DOM do iframe.
    onMx3ThemePreviewMessage(event) {
      const data = event && event.data;
      if (!data || data.source !== "mx3-theme-customizer-preview") return;
      let styleEl = document.getElementById("mx3-preview-override");
      if (!styleEl) {
        styleEl = document.createElement("style");
        styleEl.id = "mx3-preview-override";
        document.head.appendChild(styleEl);
      }
      styleEl.textContent = data.css || "";
      // Vídeo do banner em pré-visualização (tela Personalizar > Vídeo do
      // Banner) - troca em tempo real, antes de publicar. "videoTema" e
      // "videoUrl" são opcionais (só vêm quando o admin mexeu no vídeo).
      if (data.videoZoomTema) {
        const z = data.videoZoom === null || data.videoZoom === undefined || data.videoZoom === "" ? null : Number(data.videoZoom);
        this.mx3PreviewVideoZoom = { tema: data.videoZoomTema, zoom: z };
      }
      if (data.videoSpeedTema) {
        const v = data.videoSpeed === null || data.videoSpeed === undefined || data.videoSpeed === "" ? null : Number(data.videoSpeed);
        this.mx3PreviewVideoSpeed = { tema: data.videoSpeedTema, speed: v };
      }
      if (data.videoTema) {
        this.mx3PreviewVideoOverride = { tema: data.videoTema, url: data.videoUrl || "" };
        this.$nextTick(() => {
          const video = document.getElementById("bg-video");
          if (video) {
            video.load();
            video.play().catch(() => {});
          }
        });
      }
    },
    // Aplica a velocidade configurada ao <video> de fundo. Ao recarregar o
    // vídeo (troca de tema/arquivo) o navegador volta a taxa ao padrão, por
    // isso também é aplicada nos eventos loadedmetadata/play do elemento.
    mx3ApplyVideoSpeed() {
      const video = document.getElementById("bg-video");
      if (!video) return;
      const rate = this.bgVideoRate;
      try {
        video.defaultPlaybackRate = rate;
        if (video.playbackRate !== rate) video.playbackRate = rate;
      } catch (e) {
        /* taxa não suportada pelo navegador: mantém a normal */
      }
    },
    mx3DefaultVideoUrl(tema) {
      // Import Mais Brasil: um único vídeo de fundo (bancada de ferramentas) para os dois temas.
      return `${this.baseUrl}tools-video.mp4`;
    },
    // ---------------------------------------------------------------
    // "Modo Edição" da tela Personalizar (Gerenciador de Produtos)
    // ---------------------------------------------------------------
    // Quando o admin liga o "Modo Edição" no Gerenciador, esta página
    // (carregada dentro do iframe de pré-visualização) passa a: (1)
    // destacar com um contorno o elemento sob o mouse, e (2) capturar o
    // próximo clique em vez de deixá-lo navegar normalmente, extraindo
    // um seletor CSS estável e as cores atuais do elemento clicado para
    // enviar de volta ao Gerenciador (via postMessage - necessário
    // porque os dois normalmente ficam em domínios diferentes).
    onMx3ThemeEditModeMessage(event) {
      const data = event && event.data;
      if (!data || data.source !== "mx3-theme-customizer-editmode") return;
      this.mx3SetEditModeActive(!!data.active);
    },
    mx3SetEditModeActive(active) {
      if (this.mx3EditModeActive === active) return;
      this.mx3EditModeActive = active;
      // Classe no <html> enquanto o Modo Edição está ligado (libera o clique nas etiquetas do card, que no
      // site normal não recebem clique).
      document.documentElement.classList.toggle("mx3-edit-active", !!active);
      if (active) {
        document.addEventListener("click", this.mx3OnEditModeClick, true);
        // O <select> "Ordenar por" abre a lista nativa já no mousedown, antes
        // do clique: bloqueamos para o Modo Edição apenas SELECIONAR o item.
        ["mousedown", "pointerdown", "touchstart"].forEach((t) => document.addEventListener(t, this.mx3OnEditModeBlockSelect, true));
        document.addEventListener("mouseover", this.mx3OnEditModeMouseOver, true);
        document.addEventListener("mouseout", this.mx3OnEditModeMouseOut, true);
        document.addEventListener("keydown", this.mx3OnEditModeKeyDown, true);
      } else {
        document.removeEventListener("click", this.mx3OnEditModeClick, true);
        ["mousedown", "pointerdown", "touchstart"].forEach((t) => document.removeEventListener(t, this.mx3OnEditModeBlockSelect, true));
        document.removeEventListener("mouseover", this.mx3OnEditModeMouseOver, true);
        document.removeEventListener("mouseout", this.mx3OnEditModeMouseOut, true);
        document.removeEventListener("keydown", this.mx3OnEditModeKeyDown, true);
        if (this._mx3HoverEl) {
          this._mx3HoverEl.style.outline = this._mx3HoverElPrevOutline || "";
          this._mx3HoverEl.style.cursor = this._mx3HoverElPrevCursor || "";
          this._mx3HoverEl = null;
        }
      }
    },
    // Enquanto o clique é capturado aqui dentro do e-commerce (iframe), o
    // FOCO do teclado também fica aqui - por isso Delete/Ctrl+Z, mesmo
    // configurados no Gerenciador, não chegam lá sem ajuda. Repassamos via
    // postMessage, do mesmo jeito que já fazemos com o elemento clicado.
    mx3OnEditModeKeyDown(ev) {
      if (!this.mx3EditModeActive) return;
      const alvo = ev.target;
      const emCampoDeTexto = alvo && (["INPUT", "TEXTAREA", "SELECT"].includes(alvo.tagName) || alvo.isContentEditable);
      if (emCampoDeTexto) return; // não interfere ao digitar em campos do próprio site
      const isUndo = (ev.ctrlKey || ev.metaKey) && !ev.shiftKey && (ev.key === "z" || ev.key === "Z");
      const isDelete = ev.key === "Delete" || ev.key === "Backspace";
      if (!isUndo && !isDelete) return;
      ev.preventDefault();
      ev.stopPropagation();
      window.parent.postMessage({
        source: "mx3-theme-customizer-keyboard",
        action: isUndo ? "undo" : "delete",
      }, "*");
    },
    mx3OnEditModeMouseOver(ev) {
      const el = ev.target;
      if (!el || el.nodeType !== 1 || el === document.documentElement || el === document.body) return;
      if (this._mx3HoverEl && this._mx3HoverEl !== el) {
        this._mx3HoverEl.style.outline = this._mx3HoverElPrevOutline || "";
        this._mx3HoverEl.style.cursor = this._mx3HoverElPrevCursor || "";
      }
      this._mx3HoverElPrevOutline = el.style.outline;
      this._mx3HoverElPrevCursor = el.style.cursor;
      el.style.outline = "2px dashed #f0ad4e";
      el.style.cursor = "pointer";
      this._mx3HoverEl = el;
    },
    mx3OnEditModeMouseOut(ev) {
      const el = ev.target;
      if (el && this._mx3HoverEl === el) {
        el.style.outline = this._mx3HoverElPrevOutline || "";
        el.style.cursor = this._mx3HoverElPrevCursor || "";
        this._mx3HoverEl = null;
      }
    },
    mx3OnEditModeBlockSelect(ev) {
      if (!this.mx3EditModeActive) return;
      const el = ev.target;
      if (el && el.nodeType === 1 && (el.tagName === "SELECT" || el.closest(".header-sort-select-overlay"))) {
        ev.preventDefault();
        ev.stopPropagation();
      }
    },
    // Áreas do "Mapa de Elementos" relacionadas ao item clicado. Serve para
    // partes que não dá para ajustar direto pelo clique (ícone coberto pelo
    // <select> invisível, lista nativa de opções, listas suspensas que fecham
    // ao tirar o mouse, faixas atrás de outros itens). "only": o painel
    // mostra SÓ essas áreas (o próprio elemento clicado não tem cor útil).
    mx3GetMapaAreas() {
      return [
        { sel: ".header-search-sort, .header-sort-select-overlay, .header-sort-icon-visual", only: true, keys: ["hdr_sort_icon", "hdr_sort_options", "hdr_sort_select", "hdr_search_box", "hdr_search_icon"], label: "Campo de busca e botão 'Ordenar por'" },
        { sel: ".navmenu .dropdown ul", only: false, keys: ["hdr_dropdown_text", "hdr_dropdown_items", "hdr_dropdown", "hdr_dropdown_active"], label: "Lista suspensa do cabeçalho" },
        { sel: ".header-top-links", only: false, keys: ["hdr_top_strip"], label: "Faixa estreita superior" },
        { sel: ".header-category-bar", only: false, keys: ["hdr_cat_bar"], label: "Faixa estreita inferior" },
        // Quadros da seção de garantias: altura (computador e celular).
        { sel: ".guarantee-item", only: false, keys: ["gar_item_h"], label: "Quadro de garantia" },
        { sel: ".guarantees-grid, .guarantees-section, .guarantees-row-wrapper", only: false, keys: ["gar_row", "gar_grid"], label: "Seção de garantias" },
        // Cards dentro dos carrosséis das seções "Ofertas em destaque", "Produtos Recomendados" e "Quem visualizou este
        // produto, visualizou também": o quadro/fundo da imagem tem ajuste PRÓPRIO de cada seção (não mexe nos cards da
        // lista de produtos nem nas outras seções). Ficam ANTES da área genérica do card, que vale só para a lista.
        ...[
          ["ofertas", "Ofertas em destaque"],
          ["recom", "Produtos Recomendados"],
          ["visu", "Quem visualizou este produto, visualizou também"],
        ].map(([pre, nome]) => {
          const cid = { ofertas: "ofertas", recom: "recomendados", visu: "visualizados" }[pre];
          return {
            sel: '[data-mx3-carousel="' + cid + '"] .produto-card-custom',
            only: false,
            keys: [pre + "_imgbox", pre + "_img", "card_ribbon", "card_badge_express", "card_badge_free", "card_badge_low", "card_off"],
            perKey: {
              [pre + "_imgbox"]: ".produto-card-custom .product-image",
              [pre + "_img"]: ".produto-card-custom .product-image",
              card_ribbon: ".mx3-card-ribbon",
              card_badge_express: ".mx3-card-badge-express",
              card_badge_free: ".mx3-card-badge-free",
              card_badge_low: ".product-badge-low",
              card_off: ".mx3-card-off",
            },
            label: 'Item do card do produto (só na seção "' + nome + '")',
          };
        }),
        // Card do produto: o painel mostra SÓ a parte clicada (perKey = onde cada área está dentro do card).
        // Clicar no título, preço etc. segue só com o painel comum do elemento.
        {
          sel: ".produto-card-custom",
          only: false,
          keys: ["card_imgbox", "card_img", "card_ribbon", "card_badge_express", "card_badge_free", "card_badge_low", "card_off"],
          perKey: {
            card_imgbox: ".produto-card-custom .product-image",
            card_img: ".produto-card-custom .product-image",
            card_ribbon: ".mx3-card-ribbon",
            card_badge_express: ".mx3-card-badge-express",
            card_badge_free: ".mx3-card-badge-free",
            card_badge_low: ".product-badge-low",
            card_off: ".mx3-card-off",
          },
          label: "Item do card do produto (lista de produtos)",
        },
        // Seção "Ofertas em destaque" (fora dos cards): fundo e altura do fundo (computador e celular).
        { sel: ".mx3-ofertas", only: false, keys: ["ofertas_bg", "ofertas_vpad"], label: "Seção Ofertas em destaque" },
        // Imagem do produto no banner carrossel: tamanho (computador e celular).
        { sel: ".carousel-product .product-showcase", only: false, keys: ["ban_img"], label: "Conjunto da imagem do banner (computador)" },
        { sel: ".mobile-product-inner", only: false, keys: ["ban_img_m"], label: "Conjunto da imagem do banner (celular)" },
      ];
    },
    mx3OnEditModeClick(ev) {
      if (!this.mx3EditModeActive) return;
      let el = ev.target;
      if (!el || el.nodeType !== 1 || el === document.documentElement || el === document.body) return;
      // Clique no traço interno de um ícone (g/path/circle...) seleciona o ícone
      // (svg) inteiro: a cor do ícone vem do svg (fill: currentColor) e um ajuste
      // gravado só no "path" ficava mais específico e travava depois qualquer
      // ajuste feito no ícone (ex.: seta "<" do banner).
      if (el.ownerSVGElement) el = el.ownerSVGElement;
      // Clique na foto do card seleciona o QUADRO da imagem: o fundo é um só (o do quadro); a foto em si não
      // pinta fundo próprio (evita "dois fundos" atrás da imagem).
      if (el.id === "img-produto-card-list" && el.closest && el.closest(".produto-card-custom")) {
        el = el.closest(".product-image") || el;
      }
      // Clique numa logomarca seleciona a logomarca (ajustes de posição/tamanho),
      // em vez de criar uma personalização de cor.
      if (this.mx3LogoSelectActive && this.mx3LogoOf(el)) {
        ev.preventDefault();
        ev.stopPropagation();
        return;
      }
      ev.preventDefault();
      ev.stopPropagation();
      // Avisa o Gerenciador se o clique foi sobre o vídeo do banner (mostra
      // os ajustes de zoom do vídeo) ou em qualquer outro elemento (esconde).
      this.mx3EmitVideoPick(this.mx3IsOverBgVideo(el, ev));
      this.mx3EmitCarouselPick(el);
      this.mx3EmitPicked(el);
    },
    // O vídeo de fundo fica ATRÁS de tudo (z-index -1 e pointer-events: none),
    // então nunca é o alvo do clique. Consideramos "clique no vídeo" quando o
    // ponto clicado está dentro da área do vídeo e o elemento clicado (com
    // todos os pais, exceto html/body) é só uma caixa transparente, sem texto
    // próprio nem imagem - ou seja, o vídeo é o que se vê naquele ponto.
    mx3IsOverBgVideo(el, ev) {
      try {
        const video = document.getElementById("bg-video");
        if (!video || !el) return false;
        const r = video.getBoundingClientRect();
        if (ev.clientX < r.left || ev.clientX > r.right || ev.clientY < r.top || ev.clientY > r.bottom) return false;
        if (["IMG", "SVG", "PATH", "VIDEO", "CANVAS", "IFRAME", "BUTTON", "INPUT", "SELECT", "TEXTAREA", "A", "I", "LABEL"].includes(el.tagName.toUpperCase())) return false;
        for (const n of el.childNodes) {
          if (n.nodeType === 3 && n.textContent.trim() !== "") return false;
        }
        for (let n = el; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
          const cs = getComputedStyle(n);
          if (cs.backgroundImage && cs.backgroundImage !== "none") return false;
          const m = (cs.backgroundColor || "").match(/rgba?\(([^)]+)\)/);
          if (m) {
            const partes = m[1].split(",").map((x) => parseFloat(x));
            const alfa = partes.length > 3 ? partes[3] : 1;
            if (alfa > 0.02) return false;
          } else if (cs.backgroundColor && cs.backgroundColor !== "transparent") {
            return false; // formato de cor desconhecido: por segurança não assume vídeo
          }
          if (cs.visibility === "hidden") return false;
        }
        return true;
      } catch (e) {
        return false;
      }
    },
    // Clique dentro de um carrossel em movimento contínuo ("Produtos Recomendados", "Quem visualizou...",
    // "Ofertas em destaque"): avisa o Gerenciador para mostrar o ajuste de velocidade da seção.
    mx3EmitCarouselPick(el) {
      try {
        const box = el && el.closest ? el.closest("[data-mx3-carousel]") : null;
        window.parent.postMessage({
          source: "mx3-theme-customizer-carouselpicked",
          key: box ? box.getAttribute("data-mx3-carousel") : null,
          label: box ? box.getAttribute("data-mx3-carousel-label") || "" : "",
        }, "*");
      } catch (e) { /* ignora */ }
    },
    mx3EmitVideoPick(selected) {
      try {
        window.parent.postMessage({ source: "mx3-theme-customizer-videopicked", selected: !!selected }, "*");
      } catch (e) { /* ignora */ }
    },
    // Monta e envia ao Gerenciador os dados do elemento escolhido (por
    // clique, ou pelo botão "Selecionar o elemento pai").
    mx3EmitPicked(el) {
      const selector = this.mx3BuildSelector(el);
      if (!selector) return;
      const insp = this.mx3InspectElement(el);
      const textoResumo = this.mx3GetElementLabelText(el).slice(0, 28);
      const label = el.tagName.toLowerCase() + (textoResumo ? `: "${textoResumo}"` : "");
      // Este elemento pertence a um dos "conjuntos" com ajuste em grupo
      // (cards de produto, quadros de garantia, células da barra lateral
      // de categorias, quadros do banner/carrossel e abas do cabeçalho)?
      // Se sim, calculamos também o seletor "de grupo" (sem o
      // :nth-of-type do item que se repete), para que o ajuste valha
      // para todo o conjunto por padrão - ver mx3FindGroupRoot().
      const grupo = this.mx3FindGroupRoot(el);
      let groupSelector = null;
      let groupLabel = null;
      if (grupo) {
        const seletorDeGrupo = this.mx3BuildSelector(el, {
          skipNthAt: grupo.root,
          plainSelector: grupo.plainSelector,
          relativeRoot: grupo.relative ? grupo.root : null,
          relativeSel: grupo.relative ? grupo.rootSelector : null,
        });
        // Se não houver diferença (ex.: conjunto com um único item no
        // momento), não faz sentido oferecer a opção "grupo x individual".
        if (seletorDeGrupo && seletorDeGrupo !== selector) {
          groupSelector = seletorDeGrupo;
          groupLabel = grupo.label;
        }
      }
      // Este elemento representa diretamente uma das 6 cores base do
      // site (fundo geral, texto padrão, títulos, destaque, fundo de
      // cards/caixas, texto sobre destaque) e não pertence a nenhum dos
      // conjuntos acima? Ver mx3DetectBaseVar().
      const baseVar = grupo ? null : this.mx3DetectBaseVar(el);
      let mapaAreas = null;
      for (const a of this.mx3GetMapaAreas()) {
        let casa = false;
        try { casa = !!el.closest(a.sel); } catch (e) { casa = false; }
        if (casa) { mapaAreas = a; break; }
      }
      let mapaKeys = mapaAreas ? mapaAreas.keys : null;
      if (mapaAreas && mapaAreas.perKey) {
        mapaKeys = mapaAreas.keys.filter((k) => {
          try { return !!el.closest(mapaAreas.perKey[k]); } catch (e) { return false; }
        });
        // Etiqueta/faixa clicada (que fica DENTRO do quadro da imagem): mostra só a etiqueta, sem o quadro da imagem.
        const ehQuadroDaImagem = (k) => /^(card|ofertas|recom|visu)_(imgbox|img)$/.test(k);
        if (mapaKeys.some((k) => !ehQuadroDaImagem(k))) {
          mapaKeys = mapaKeys.filter((k) => !ehQuadroDaImagem(k));
        }
        if (!mapaKeys.length) mapaKeys = null;
      }
      window.parent.postMessage({
        source: "mx3-theme-customizer-elementpicked",
        payload: {
          selector,
          groupSelector,
          groupLabel,
          label,
          baseVar: baseVar ? baseVar.key : null,
          baseVarLabel: baseVar ? baseVar.label : null,
          baseVarDual: !!(baseVar && baseVar.dual),
          mapaKeys,
          mapaOnly: !!(mapaAreas && mapaAreas.only),
          mapaLabel: mapaKeys && mapaAreas ? mapaAreas.label : null,
          ...insp,
        },
      }, "*");
    },
    // ---------- Logomarcas (cabeçalho e rodapé): selecionar, posição e tamanho ----------
    // Dentro da pré-visualização do Personalizar, clicar numa logomarca (cabeçalho
    // ou rodapé) a seleciona e avisa o Gerenciador, que então mostra os ajustes de
    // posição e tamanho daquela logomarca. Com o "Posicionar logomarca" ligado
    // também dá para arrastá-la / usar as setas do teclado.
    mx3LogoDefs() {
      return {
        header: { sel: "#header .main-header .logo", top: "--mx3-logo-top", left: "--mx3-logo-left", height: "--mx3-logo-height" },
        footer: { sel: ".footer .footer-about .logo", top: "--mx3-footer-logo-top", left: "--mx3-footer-logo-left", height: "--mx3-footer-logo-height" },
      };
    },
    onMx3LogoMessage(event) {
      const d = event && event.data;
      if (!d) return;
      if (d.source === "mx3-theme-customizer-logoset") {
        if (d.logos && typeof d.logos === "object") {
          Object.keys(this.mx3LogoDefs()).forEach((which) => this.mx3ApplyLogoVars(which, d.logos[which] || {}));
        } else {
          this.mx3ApplyLogoVars("header", { top: d.top, left: d.left });
        }
      } else if (d.source === "mx3-theme-customizer-logomove") {
        this.mx3SetLogoMoveActive(!!d.active);
      } else if (d.source === "mx3-theme-customizer-logoselect") {
        this.mx3SetLogoSelectActive(!!d.enabled);
      }
    },
    mx3ApplyLogoVars(which, v) {
      const def = this.mx3LogoDefs()[which];
      if (!def) return;
      const root = document.documentElement;
      [["top", def.top], ["left", def.left], ["height", def.height]].forEach(([campo, nome]) => {
        const valor = v ? v[campo] : null;
        if (valor === null || valor === undefined || valor === "" || isNaN(Number(valor))) root.style.removeProperty(nome);
        else root.style.setProperty(nome, Number(valor) + "px");
      });
    },
    mx3LogoOf(alvo) {
      if (!alvo || !alvo.closest) return null;
      const defs = this.mx3LogoDefs();
      for (const which of Object.keys(defs)) {
        if (alvo.closest(defs[which].sel)) return which;
      }
      return null;
    },
    mx3CurrentLogoPos(which) {
      const def = this.mx3LogoDefs()[which || "header"];
      const cs = getComputedStyle(document.documentElement);
      const t = parseFloat(cs.getPropertyValue(def.top));
      const l = parseFloat(cs.getPropertyValue(def.left));
      return { top: isNaN(t) ? 0 : t, left: isNaN(l) ? 0 : l };
    },
    mx3EmitLogoPos(phase, which, pos) {
      try {
        window.parent.postMessage({ source: "mx3-theme-customizer-logopos", phase, which, top: Math.round(pos.top), left: Math.round(pos.left) }, "*");
      } catch (e) { /* ignora */ }
    },
    // Avisa o Gerenciador qual logomarca está selecionada (ou nenhuma): os ajustes
    // de posição/tamanho só aparecem enquanto houver uma logomarca selecionada.
    mx3EmitLogoSelect(which) {
      try {
        window.parent.postMessage({ source: "mx3-theme-customizer-logopos", phase: "select", selected: !!which, which: which || null }, "*");
      } catch (e) { /* ignora */ }
    },
    mx3SetLogoSel(which) {
      const root = document.documentElement;
      root.classList.remove("mx3-logo-sel-header", "mx3-logo-sel-footer");
      this._mx3LogoSel = which || null;
      if (which) root.classList.add("mx3-logo-sel-" + which);
    },
    mx3SetLogoMoveActive(active) {
      this.mx3LogoMoveActive = !!active;
      document.documentElement.classList.toggle("mx3-logo-move", !!active);
    },
    mx3SetLogoSelectActive(active) {
      if (this.mx3LogoSelectActive === active) return;
      this.mx3LogoSelectActive = active;
      let st = document.getElementById("mx3-logosel-style");
      const root = document.documentElement;
      if (active) {
        if (!st) {
          st = document.createElement("style");
          st.id = "mx3-logosel-style";
          st.textContent =
            "html.mx3-logo-select #header .main-header .logo,html.mx3-logo-select .footer .footer-about .logo{cursor:pointer;pointer-events:auto}" +
            "html.mx3-logo-select.mx3-logo-move #header .main-header .logo .logo-site-img,html.mx3-logo-select.mx3-logo-move .footer .footer-about .logo .logo-site-img{cursor:move !important;touch-action:none}" +
            "html.mx3-logo-sel-header #header .main-header .logo .logo-site-img,html.mx3-logo-sel-footer .footer .footer-about .logo .logo-site-img{outline:2px dashed #ff8c00;outline-offset:3px}";
          document.head.appendChild(st);
        }
        root.classList.add("mx3-logo-select");
        document.addEventListener("pointerdown", this.mx3LogoPointerDown, true);
        document.addEventListener("click", this.mx3LogoClick, true);
        document.addEventListener("keydown", this.mx3LogoKeyDown, true);
      } else {
        if (st) st.remove();
        root.classList.remove("mx3-logo-select");
        document.removeEventListener("pointerdown", this.mx3LogoPointerDown, true);
        document.removeEventListener("click", this.mx3LogoClick, true);
        document.removeEventListener("keydown", this.mx3LogoKeyDown, true);
        if (this._mx3LogoSel) this.mx3EmitLogoSelect(null);
        this.mx3SetLogoSel(null);
      }
    },
    mx3LogoPointerDown(ev) {
      const which = this.mx3LogoOf(ev.target);
      if (!which) {
        if (this._mx3LogoSel) {
          this.mx3SetLogoSel(null);
          this.mx3EmitLogoSelect(null);
        }
        return;
      }
      ev.preventDefault();
      ev.stopPropagation();
      if (this._mx3LogoSel !== which) {
        this.mx3SetLogoSel(which);
        this.mx3EmitLogoSelect(which);
      }
      if (!this.mx3LogoMoveActive) return;
      const start = this.mx3CurrentLogoPos(which);
      const x0 = ev.clientX, y0 = ev.clientY;
      this.mx3EmitLogoPos("start", which, start);
      const aplicar = (pos) => {
        const def = this.mx3LogoDefs()[which];
        document.documentElement.style.setProperty(def.top, pos.top + "px");
        document.documentElement.style.setProperty(def.left, pos.left + "px");
      };
      const move = (e2) => {
        const pos = { top: start.top + (e2.clientY - y0), left: start.left + (e2.clientX - x0) };
        aplicar(pos);
        this.mx3EmitLogoPos("move", which, pos);
      };
      const up = () => {
        document.removeEventListener("pointermove", move, true);
        document.removeEventListener("pointerup", up, true);
        this.mx3EmitLogoPos("end", which, this.mx3CurrentLogoPos(which));
      };
      document.addEventListener("pointermove", move, true);
      document.addEventListener("pointerup", up, true);
    },
    mx3LogoClick(ev) {
      // Na pré-visualização, clicar na logomarca só seleciona (não navega para a Home).
      if (this.mx3LogoOf(ev.target)) {
        ev.preventDefault();
        ev.stopPropagation();
      }
    },
    mx3LogoKeyDown(ev) {
      if (ev.key === "Escape") {
        if (this._mx3LogoSel) {
          this.mx3SetLogoSel(null);
          this.mx3EmitLogoSelect(null);
        }
        return;
      }
      const which = this._mx3LogoSel;
      if (!which || !this.mx3LogoMoveActive) return;
      const passo = ev.shiftKey ? 10 : 1;
      const map = { ArrowUp: [0, -passo], ArrowDown: [0, passo], ArrowLeft: [-passo, 0], ArrowRight: [passo, 0] };
      const m = map[ev.key];
      if (!m) return;
      ev.preventDefault();
      const cur = this.mx3CurrentLogoPos(which);
      const pos = { top: cur.top + m[1], left: cur.left + m[0] };
      const def = this.mx3LogoDefs()[which];
      document.documentElement.style.setProperty(def.top, pos.top + "px");
      document.documentElement.style.setProperty(def.left, pos.left + "px");
      this.mx3EmitLogoPos("nudge", which, pos);
    },
    // ---------- Mapa de Elementos: localizar / elemento pai ----------
    onMx3ThemeLocateMessage(event) {
      const data = event && event.data;
      if (!data) return;
      if (data.source === "mx3-theme-customizer-select-parent") {
        let atual = null;
        try { atual = document.querySelector(data.selector); } catch (e) { atual = null; }
        let pai = atual && atual.parentElement;
        while (pai && pai.tagName && pai.tagName.toLowerCase() === "html") pai = null;
        if (!pai || pai === document.body) return;
        this.mx3EmitPicked(pai);
        return;
      }
      if (data.source !== "mx3-theme-customizer-locate") return;
      // Listas suspensas (Categorias/Serviços) só aparecem com o mouse em
      // cima; ao localizar uma delas mantemos a lista aberta por alguns
      // segundos para dar para ver o resultado do ajuste.
      const estiloAberto = document.getElementById("mx3-force-open");
      if (estiloAberto) estiloAberto.remove();
      if (!data.silent && data.open && /^[\w\s.#>\-\[\]=*:"',]+$/.test(String(data.open))) {
        const st = document.createElement("style");
        st.id = "mx3-force-open";
        st.textContent = `${data.open}{opacity:1 !important;visibility:visible !important;top:100% !important;display:block !important;}`;
        document.head.appendChild(st);
        setTimeout(() => { const x = document.getElementById("mx3-force-open"); if (x) x.remove(); }, 12000);
      }
      const responder = (el) => {
        const resp = { source: "mx3-theme-customizer-locate-result", key: data.key, tema: data.tema, found: !!el };
        if (el) {
          const cs = getComputedStyle(el);
          resp.bg = this.mx3ColorToCss(cs.backgroundColor);
          if (!resp.bg) {
            // Fundo transparente ou em degradê: usa a cor realmente visível
            // (1a cor do degradê; senão, a do primeiro elemento acima com fundo).
            let n = el;
            while (n && n.nodeType === 1 && !resp.bg) {
              const c = getComputedStyle(n);
              resp.bg = this.mx3ColorToCss(c.backgroundColor);
              if (!resp.bg && c.backgroundImage && c.backgroundImage !== "none") {
                const g = c.backgroundImage.match(/rgba?\([^)]*\)/i);
                if (g) resp.bg = this.mx3ColorToCss(g[0]);
              }
              n = n.parentElement;
            }
          }
          resp.color = this.mx3ColorToCss(cs.color);
          try {
            const nv = this.mx3ResolveNormalStyle(el);
            resp.grad = nv.grad;
            if (!resp.bg) resp.bg = nv.visibleBg || "";
            const hv = this.mx3ResolveHoverStyle(el);
            resp.hover_bg = hv.bg;
            resp.hover_color = hv.color;
            resp.hover_grad = hv.grad;
          } catch (e) { /* ignora */ }
          resp.border = this.mx3ColorToCss(cs.borderTopColor);
        }
        try { window.parent.postMessage(resp, "*"); } catch (e) { /* ignora */ }
      };
      const achar = () => {
        const partes = String(data.sel || "").split(",").map((x) => x.trim()).filter(Boolean);
        for (const p of partes) {
          let lista = [];
          try { lista = Array.from(document.querySelectorAll(p)); } catch (e) { continue; }
          const visivel = lista.find((n) => { const r = n.getBoundingClientRect(); return r.width > 0 && r.height > 0; });
          if (visivel) return visivel;
        }
        return null;
      };
      const destacar = (el) => {
        try { el.scrollIntoView({ block: "center", inline: "nearest", behavior: "smooth" }); } catch (e) { /* ignora */ }
        const antes = { o: el.style.outline, f: el.style.outlineOffset };
        el.style.outline = "3px solid #ff3b9a";
        el.style.outlineOffset = "-3px";
        setTimeout(() => { el.style.outline = antes.o; el.style.outlineOffset = antes.f; }, 1800);
      };
      let el = achar();
      // Leitura silenciosa (só pega as cores atuais): sem destaque, rolagem nem troca de página.
      if (data.silent) { responder(el); return; }
      if (el) { destacar(el); responder(el); return; }
      // Não está na página atual: tenta abrir a página onde ele costuma ficar.
      const alvoPagina = data.page && this.$route.path.replace(/\/$/, "") !== String(data.page).replace(/\/$/, "");
      if (alvoPagina) {
        this.$router.push(data.page).catch(() => {});
        setTimeout(() => {
          el = achar();
          if (el) destacar(el);
          responder(el);
        }, 1500);
      } else {
        responder(null);
      }
    },
    // ---------- "Conjuntos" com ajuste em grupo x individual ----------
    // Cada grupo aponta para a classe CSS do item que SE REPETE (o card,
    // o quadro, a célula...). mx3FindGroupRoot() sobe a árvore a partir
    // do elemento clicado procurando o item do conjunto ao qual ele
    // pertence (o próprio elemento clicado ou algum ancestral).
    mx3GetElementGroups() {
      return [
        // relative: o seletor do grupo é montado a partir do próprio card (".produto-card-custom > ..."), sem os
        // ancestrais: assim o ajuste vale para os cards de TODAS as seções (grade, Ofertas em destaque,
        // Produtos Recomendados, Quem visualizou também...), e não só para os da lista onde se clicou.
        { id: "product-card", rootSelector: ".produto-card-custom", label: "Cards de produtos", relative: true },
        { id: "guarantee-item", rootSelector: ".guarantee-item", label: "Quadros da seção de garantias" },
        { id: "category-item", rootSelector: ".category-item", label: "Células da barra lateral de categorias" },
        // Células da barra lateral de categorias da página de produtos / Home
        // (Products.vue usa a classe .filter-item).
        { id: "filter-item", rootSelector: ".filter-item", plainSelector: ".category-list > li", label: "Células da barra lateral de categorias" },
        { id: "stat-card", rootSelector: ".stat-card", label: "Quadros do banner/carrossel" },
        // Itens das listas suspensas do cabeçalho (Categorias/Serviços).
        // Fica ANTES de "nav-tab-item" porque esses <li> estão dentro de um
        // <li class="nav-tab-item"> e precisam ser reconhecidos primeiro.
        { id: "nav-dropdown-item", rootSelector: ".navmenu .dropdown ul > li", label: "Itens das listas suspensas do cabeçalho (Categorias/Serviços)" },
        // Marcador adicionado nos <li> de nível superior da faixa de
        // categorias do cabeçalho (Início, Categorias, Serviços, etc.) -
        // ver Header.vue.
        { id: "nav-tab-item", rootSelector: ".nav-tab-item", label: "Abas do menu do cabeçalho" },
      ];
    },
    mx3FindGroupRoot(el) {
      const grupos = this.mx3GetElementGroups();
      for (const grupo of grupos) {
        const root = el.closest(grupo.rootSelector);
        if (root) return { ...grupo, root };
      }
      return null;
    },
    // ---------- As 6 cores base do site (antiga seção "Cores Globais") ----------
    // Em vez de uma seção fixa no painel, essas cores continuam
    // editáveis clicando no elemento correspondente: comparamos a cor
    // JÁ RESOLVIDA do elemento clicado com o valor atual de cada
    // variável CSS raiz - se baterem (e o elemento não pertencer a um
    // dos conjuntos acima, que têm sua própria lógica de grupo/
    // individual), o clique edita a cor base (afeta o site inteiro),
    // em vez de criar uma personalização só daquele elemento.
    mx3DetectBaseVar(el) {
      const raiz = getComputedStyle(document.documentElement);
      const varAtual = (nome) => (raiz.getPropertyValue(nome) || "").trim();
      const cs = getComputedStyle(el);
      const elBg = this.mx3RgbToHex(cs.backgroundColor);
      const elColor = this.mx3RgbToHex(cs.color);
      const tag = el.tagName.toLowerCase();
      const ehTitulo = /^h[1-6]$/.test(tag);
      const bate = (valorEl, nomeVar) => {
        const v = varAtual(nomeVar);
        return !!valorEl && !!v && valorEl.toLowerCase() === v.toLowerCase();
      };
      // Fundo do degradê atrás dos cards de produtos (e da seção de Parceiros)
      // e fundo dos quadros dos parceiros: têm variáveis próprias, então o clique
      // edita a variável (reflete na publicação) em vez de um ajuste solto.
      if (el.closest && el.closest(".partner-card")) {
        return { key: "partner_card_bg", label: "Fundo dos quadros dos parceiros", dual: false };
      }
      if (
        el.matches &&
        el.matches(
          ".products-row-wrapper, .products-col-wrapper, .partners-row-wrapper, .partners-col-wrapper, .partners-section, .scrolling-logos, .logos-slide, .logos-group, .container-de-produto-margin"
        )
      ) {
        return { key: "products_area_bg", label: "Fundo da área de produtos (degradê até Parceiros)", dual: false };
      }
      if (bate(elBg, "--background-color")) {
        return { key: "background_color", label: "Fundo geral do site", dual: false };
      }
      if (bate(elBg, "--surface-color")) {
        return { key: "surface_color", label: "Fundo de cards/caixas (cor base do site)", dual: true };
      }
      if (bate(elColor, "--contrast-color")) {
        return { key: "contrast_color", label: "Texto sobre destaque (cor base do site)", dual: true };
      }
      if (ehTitulo && bate(elColor, "--heading-color")) {
        return { key: "heading_color", label: "Cor de títulos (cor base do site)", dual: true };
      }
      if (bate(elColor, "--accent-color") || bate(elBg, "--accent-color")) {
        return { key: "accent_color", label: "Cor de destaque (cor base do site)", dual: true };
      }
      if (bate(elColor, "--default-color")) {
        return { key: "default_color", label: "Texto padrão do site", dual: false };
      }
      return null;
    },
    // el.textContent gruda o texto de blocos filhos adjacentes sem
    // espaço nenhum entre eles (ex.: um <h5>Compra Segura</h5> seguido
    // de <p>Certificado SSL</p> vira "Compra SeguraCertificado SSL" no
    // rótulo mostrado no Gerenciador). Aqui inserimos um espaço entre
    // o texto de cada nó, dando "Compra Segura Certificado SSL".
    mx3GetElementLabelText(el) {
      const partes = [];
      const percorrer = (node) => {
        if (node.nodeType === 3) {
          const t = node.textContent.trim();
          if (t) partes.push(t);
        } else if (node.nodeType === 1) {
          node.childNodes.forEach(percorrer);
        }
      };
      percorrer(el);
      return partes.join(" ");
    },
    // Gera um seletor CSS razoavelmente estável para o elemento clicado:
    // usa #id quando existir; senão monta um caminho tag(.classes
    // estáveis)?(:nth-of-type quando há irmãos do mesmo tipo) subindo
    // até 6 níveis - suficiente para identificar o elemento sem
    // depender de classes utilitárias/dinâmicas (ex.: as de
    // animação/estado do Vue, filtradas abaixo).
    // "opts.skipNthAt", quando informado, é o elemento (ancestral do
    // clicado) que é a RAIZ de um item repetido de um conjunto (ex.: um
    // card de produto específico dentro da grade). Omitir o
    // :nth-of-type só nesse nível produz um seletor que casa com TODOS
    // os itens do conjunto (o ajuste em grupo) em vez de só aquele -
    // ver mx3FindGroupRoot()/mx3OnEditModeClick().
    mx3BuildSelector(el, opts) {
      const skipNthAt = opts && opts.skipNthAt;
      // plainSelector (opcional): ancestrais que casam com ele entram no caminho só
      // com a tag (sem classes nem :nth-of-type). Usado nos conjuntos em que cada
      // item fica dentro do SEU próprio wrapper (ex.: cada célula de categoria
      // dentro de um <li>), para o seletor do grupo valer para todos os itens.
      const plainSelector = opts && opts.plainSelector;
      const parts = [];
      let node = el;
      let depth = 0;
      const relativeRoot = opts && opts.relativeRoot;
      while (node && node.nodeType === 1 && node.tagName.toLowerCase() !== "html" && (relativeRoot || depth < 8)) {
        if (relativeRoot && node === relativeRoot) {
          parts.unshift(opts.relativeSel || "." + Array.from(node.classList)[0]);
          break;
        }
        if (node.id) {
          parts.unshift("#" + CSS.escape(node.id));
          break;
        }
        let parte = node.tagName.toLowerCase();
        let ehPlain = false;
        if (plainSelector && node !== el) {
          try { ehPlain = node.matches(plainSelector); } catch (e) { ehPlain = false; }
        }
        if (ehPlain) {
          parts.unshift(parte);
          node = node.parentElement;
          depth++;
          continue;
        }
        const classesEstaveis = Array.from(node.classList || [])
          .filter((c) => c && !/^(fade|enter|leave|active|show|hide|hover)/i.test(c))
          .slice(0, 2);
        if (classesEstaveis.length) {
          parte += "." + classesEstaveis.map((c) => CSS.escape(c)).join(".");
        }
        const pai = node.parentElement;
        if (pai && node !== skipNthAt) {
          let irmaosMesmoTipo = Array.from(pai.children).filter((s) => s.tagName === node.tagName);
          // Dentro de um item repetido (relativeRoot), partes opcionais (ex.: a faixa de desconto, que só existe em
          // alguns cards) mudam o índice dos irmãos: se a parte tem classe própria e é única entre os irmãos com
          // essa classe, o :nth-of-type é dispensável (e atrapalharia os cards sem a parte opcional).
          if (relativeRoot && classesEstaveis.length) {
            const unicos = irmaosMesmoTipo.filter((s) => classesEstaveis.every((c) => s.classList.contains(c)));
            if (unicos.length === 1) irmaosMesmoTipo = [node];
          }
          if (irmaosMesmoTipo.length > 1) {
            parte += `:nth-of-type(${irmaosMesmoTipo.indexOf(node) + 1})`;
          }
        }
        parts.unshift(parte);
        node = node.parentElement;
        depth++;
      }
      return parts.join(" > ");
    },
    mx3RgbToHex(rgbStr) {
      if (!rgbStr) return "";
      const m = String(rgbStr).match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*([\d.]+))?\)/i);
      if (!m) return "";
      if (m[4] !== undefined && parseFloat(m[4]) === 0) return ""; // transparente
      const toHex = (n) => Number(n).toString(16).padStart(2, "0");
      return "#" + toHex(m[1]) + toHex(m[2]) + toHex(m[3]);
    },
    // Igual ao mx3RgbToHex, mas PRESERVA a transparência: cor opaca -> "#rrggbb";
    // cor translúcida (ex.: rgba(255,102,0,0.15)) -> "#rrggbbaa" (CSS válido, e o
    // controle de "Transparência" do Gerenciador já entende). Cor totalmente
    // transparente -> "". Usada nas cores enviadas ao Gerenciador como valor
    // atual/pré-preenchimento: antes o alfa era descartado e uma cor translúcida
    // virava sólida (ex.: laranja a 15% virava laranja 100%) ao selecionar o elemento.
    mx3ColorToCss(rgbStr) {
      if (!rgbStr) return "";
      const m = String(rgbStr).match(/rgba?\(\s*(\d+)[\s,]+(\d+)[\s,]+(\d+)(?:\s*[,/]\s*([\d.]+)(%?))?\s*\)/i);
      if (!m) return "";
      let alfa = 1;
      if (m[4] !== undefined) alfa = parseFloat(m[4]) / (m[5] === "%" ? 100 : 1);
      if (isNaN(alfa) || alfa <= 0) return ""; // transparente
      const toHex = (n) => Math.max(0, Math.min(255, Number(n))).toString(16).padStart(2, "0");
      const base = "#" + toHex(m[1]) + toHex(m[2]) + toHex(m[3]);
      if (alfa >= 1) return base;
      return base + toHex(Math.round(alfa * 255));
    },
    // ---------- Leitura das cores/gradientes APLICADOS (normal, hover, ativo) ----------
    // Converte qualquer cor CSS (nome, hsl, rgb, hex, var()) em "#RRGGBB[AA]" usando o próprio navegador.
    mx3NormalizeColor(token) {
      let t = String(token || "").trim();
      if (!t) return "";
      t = this.mx3ResolveVars(t);
      if (/^transparent$/i.test(t)) return "";
      const hex = t.match(/^#([0-9a-f]{3,8})$/i);
      if (hex) {
        let h = hex[1];
        if (h.length === 3 || h.length === 4) h = h.split("").map((c) => c + c).join("");
        if (h.length === 6 || h.length === 8) return "#" + h.toLowerCase();
      }
      try {
        const sp = document.createElement("span");
        sp.style.cssText = "position:absolute;left:-9999px;top:-9999px;visibility:hidden;color:#010203";
        sp.style.color = t;
        document.body.appendChild(sp);
        const c = getComputedStyle(sp).color;
        document.body.removeChild(sp);
        if (c === "rgb(1, 2, 3)" && !/#010203|rgb\(\s*1\s*,\s*2\s*,\s*3\s*\)/i.test(t)) return ""; // cor inválida: o navegador ignorou
        return this.mx3ColorToCss(c);
      } catch (e) {
        return "";
      }
    },
    // Troca var(--x, fallback) pelo valor atual da variável (raiz do documento) ou pelo fallback.
    mx3ResolveVars(texto) {
      let t = String(texto || "");
      for (let i = 0; i < 4 && /var\(/.test(t); i++) {
        t = t.replace(/var\(\s*(--[\w-]+)\s*(?:,\s*([^()]*(?:\([^()]*\)[^()]*)*))?\)/g, (m, nome, fb) => {
          let v = "";
          try { v = getComputedStyle(document.documentElement).getPropertyValue(nome).trim(); } catch (e) { v = ""; }
          return v || (fb || "").trim() || "transparent";
        });
      }
      return t;
    },
    // Divide "a, b(c,d), e" na vírgula de nível zero.
    mx3SplitTop(texto) {
      const out = [];
      let nivel = 0, atual = "";
      for (const ch of String(texto || "")) {
        if (ch === "(") nivel++;
        if (ch === ")") nivel--;
        if (ch === "," && nivel === 0) { out.push(atual.trim()); atual = ""; } else atual += ch;
      }
      if (atual.trim()) out.push(atual.trim());
      return out;
    },
    // "linear-gradient(135deg, A 0%, B 100%)" -> { c1, c2, ang } (1ª e última cor); null se não for linear-gradient de 2+ cores.
    mx3ParseGradient(valor) {
      const bruto = this.mx3ResolveVars(String(valor || ""));
      const m = bruto.match(/linear-gradient\((.*)\)\s*(?:,|$)/is);
      if (!m) return null;
      let partes = this.mx3SplitTop(m[1]);
      let ang = 180;
      if (partes.length && /^(to\s|[-\d.]+(deg|turn|rad|grad))/i.test(partes[0])) {
        const a = partes.shift();
        const dg = a.match(/^(-?[\d.]+)deg/i);
        if (dg) ang = Math.round(parseFloat(dg[1]));
        else {
          const mapa = { "to top": 0, "to right": 90, "to bottom": 180, "to left": 270, "to top right": 45, "to right top": 45, "to bottom right": 135, "to right bottom": 135, "to bottom left": 225, "to left bottom": 225, "to top left": 315, "to left top": 315 };
          ang = mapa[a.toLowerCase().replace(/\s+/g, " ").trim()] ?? 180;
        }
      }
      const cores = partes
        .map((p) => this.mx3NormalizeColor(p.replace(/\s+-?[\d.]+(%|px|em|rem)?\s*$/i, "").trim()))
        .filter((c) => c);
      if (cores.length < 2) return null;
      return { c1: cores[0], c2: cores[cores.length - 1], ang: ((ang % 360) + 360) % 360 };
    },
    // Especificidade aproximada de um seletor: [ids, classes/atributos/pseudo-classes, tags].
    mx3Specificity(sel) {
      let s = String(sel || "").replace(/:where\([^)]*\)/g, "");
      const ids = (s.match(/#[\w-]+/g) || []).length;
      s = s.replace(/#[\w-]+/g, "");
      const cls = (s.match(/\.[\w-]+|\[[^\]]*\]|:(?!:)[\w-]+/g) || []).length;
      s = s.replace(/\.[\w-]+|\[[^\]]*\]|::?[\w-]+(\([^)]*\))?/g, " ");
      const tags = (s.match(/(^|[\s>+~(])[a-zA-Z][\w-]*/g) || []).length;
      return ids * 10000 + cls * 100 + tags;
    },
    // Lista (achatada, em ordem) as regras de estilo do site, entrando em @media/@supports que valem agora.
    mx3FlatRules() {
      const out = [];
      const visitar = (rules) => {
        for (const r of Array.from(rules || [])) {
          if (r.selectorText) out.push(r);
          else if (r.cssRules) {
            if (r.media) {
              let ok = true;
              try { ok = window.matchMedia(r.media.mediaText).matches; } catch (e) { ok = true; }
              if (!ok) continue;
            }
            visitar(r.cssRules);
          }
        }
      };
      for (const sheet of Array.from(document.styleSheets)) {
        let rules;
        try { rules = sheet.cssRules || sheet.rules; } catch (e) { continue; }
        if (rules) visitar(rules);
      }
      return out;
    },
    // Estilo APLICADO no estado "hover" (':hover' nas regras do site, incluindo os ajustes já publicados/da pré-visualização):
    // { found, bg, grad, color }. Em cada propriedade vence a regra com !important, depois a de maior especificidade, depois a mais recente.
    mx3ResolveHoverStyle(el) {
      const melhor = {};
      const regras = this.mx3FlatRules();
      regras.forEach((rule, ordem) => {
        if (rule.selectorText.indexOf(":hover") === -1) return;
        for (const parte of this.mx3SplitTop(rule.selectorText)) {
          if (parte.indexOf(":hover") === -1) continue;
          const base = parte.replace(/:hover/g, "");
          let casa = false;
          try { casa = !!base && el.matches(base); } catch (e) { casa = false; }
          if (!casa) continue;
          const spec = this.mx3Specificity(parte);
          const st = rule.style;
          [["bg", "background-color"], ["img", "background-image"], ["color", "color"]].forEach(([k, prop]) => {
            const v = st.getPropertyValue(prop);
            if (!v) return;
            const imp = st.getPropertyPriority(prop) === "important" ? 1 : 0;
            const chave = [imp, spec, ordem];
            const atual = melhor[k];
            if (!atual || chave[0] > atual.k[0] || (chave[0] === atual.k[0] && (chave[1] > atual.k[1] || (chave[1] === atual.k[1] && chave[2] >= atual.k[2])))) {
              melhor[k] = { v, k: chave };
            }
          });
        }
      });
      const found = !!(melhor.bg || melhor.img || melhor.color);
      const grad = melhor.img ? this.mx3ParseGradient(melhor.img.v) : null;
      let bg = melhor.bg ? this.mx3NormalizeColor(melhor.bg.v) : "";
      if (!bg && grad) bg = grad.c1;
      return { found, bg, grad, color: melhor.color ? this.mx3NormalizeColor(melhor.color.v) : "" };
    },
    // Cor/gradiente VISÍVEIS do elemento no estado normal: sobe pelos ancestrais quando o próprio fundo é transparente.
    mx3ResolveNormalStyle(el) {
      const cs = getComputedStyle(el);
      const grad = this.mx3ParseGradient(cs.backgroundImage);
      const proprio = this.mx3ColorToCss(cs.backgroundColor);
      let visivel = proprio || (grad ? grad.c1 : "");
      let n = el.parentElement;
      while (!visivel && n && n.nodeType === 1) {
        const c = getComputedStyle(n);
        visivel = this.mx3ColorToCss(c.backgroundColor);
        if (!visivel) { const g = this.mx3ParseGradient(c.backgroundImage); if (g) visivel = g.c1; }
        n = n.parentElement;
      }
      return { bg: proprio, visibleBg: visivel, grad };
    },
    // Detecta se o elemento tem borda visível e se existe alguma regra
    // ":hover" no CSS do site que se aplique a ele, reaproveitando (sem
    // o sufixo ":hover") o próprio seletor da regra para checar
    // el.matches(). Sempre que possível, também extrai a cor de fundo/
    // texto usadas nesse hover, para pré-preencher os campos no
    // Gerenciador.
    mx3InspectElement(el) {
      const cs = window.getComputedStyle(el);
      // Checa as 4 bordas (não só a de cima): títulos como "Categorias"
      // costumam usar só border-bottom (uma linha por baixo do texto), e
      // antes isso não era detectado - o campo "Cor da borda" nunca
      // aparecia pra esses elementos, mesmo a borda existindo de verdade.
      const temBorda = (largura, estilo) => (parseFloat(largura) || 0) > 0 && estilo !== "none";
      const hasBorder = temBorda(cs.borderTopWidth, cs.borderTopStyle) ||
        temBorda(cs.borderRightWidth, cs.borderRightStyle) ||
        temBorda(cs.borderBottomWidth, cs.borderBottomStyle) ||
        temBorda(cs.borderLeftWidth, cs.borderLeftStyle);
      // Detecta o padrão "texto com gradiente" (ex.: título grande do
      // banner): o texto normalmente é preenchido via -webkit-text-fill-
      // color transparente + background-clip:text, então trocar apenas
      // "color" ou "background-color" não muda nada visualmente - é
      // preciso tratar esse caso à parte (ver textClip abaixo e a
      // geração de CSS em theme_customizer_manager.js/theme_config_manager.php).
      const fillColor = cs.webkitTextFillColor || cs.textFillColor || "";
      const bgClip = cs.webkitBackgroundClip || cs.backgroundClip || "";
      const fillMatch = String(fillColor).match(/rgba?\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*(?:,\s*([\d.]+)\s*)?\)/i);
      const fillIsTransparent = fillColor === "transparent" || (fillMatch && fillMatch[1] !== undefined && parseFloat(fillMatch[1]) === 0);
      const textClip = bgClip.indexOf("text") !== -1 && fillIsTransparent;
      let hasHover = false;
      let hoverBackground = "";
      let hoverColor = "";
      // Estado "ao ser clicado" (ex.: categoria/aba selecionada, item de
      // paginação ativo): mesma técnica do hover acima, mas procurando
      // regras cujo seletor combine o elemento com uma classe de
      // estado "ativo/selecionado" já usada no projeto.
      let hasActive = false;
      let activeBackground = "";
      let activeColor = "";
      let activeGradient = null;
      let activeClass = ""; // ex.: ".is-active" - a classe de estado que casou (ver abaixo)
      const REGEX_CLASSE_ATIVA = /\.(is-active|active|selected)\b/;
      try {
        for (const sheet of document.styleSheets) {
          let rules;
          try {
            rules = sheet.cssRules || sheet.rules;
          } catch (e) {
            continue; // folha de outra origem (ex.: Google Fonts) - ignora
          }
          if (!rules) continue;
          for (const rule of rules) {
            if (!rule.selectorText) continue;
            if (rule.selectorText.indexOf(":hover") !== -1) {
              const seletorBase = rule.selectorText.replace(/:hover/g, "");
              try {
                if (seletorBase && el.matches(seletorBase)) {
                  hasHover = true;
                  if (rule.style && rule.style.backgroundColor) {
                    hoverBackground = this.mx3ColorToCss(rule.style.backgroundColor) || hoverBackground;
                  }
                  if (rule.style && rule.style.color) {
                    hoverColor = this.mx3ColorToCss(rule.style.color) || hoverColor;
                  }
                }
              } catch (e) {
                // seletor inválido/incompatível com este elemento - ignora
              }
            } else if (REGEX_CLASSE_ATIVA.test(rule.selectorText)) {
              // Remove a classe de estado ativo do seletor para checar
              // se o elemento CASARIA com ele quando ativo (mesmo que
              // ainda não esteja, no momento do clique).
              const seletorSemAtivo = rule.selectorText.replace(REGEX_CLASSE_ATIVA, "");
              try {
                if (seletorSemAtivo && seletorSemAtivo !== rule.selectorText && el.matches(seletorSemAtivo)) {
                  hasActive = true;
                  const casouClasse = rule.selectorText.match(REGEX_CLASSE_ATIVA);
                  if (casouClasse) activeClass = "." + casouClasse[1];
                  if (rule.style && rule.style.backgroundColor) {
                    activeBackground = this.mx3ColorToCss(rule.style.backgroundColor) || activeBackground;
                  }
                  if (rule.style && rule.style.backgroundImage) {
                    const ga = this.mx3ParseGradient(rule.style.backgroundImage);
                    if (ga) { activeGradient = ga; if (!activeBackground) activeBackground = ga.c1; }
                  }
                  if (rule.style && rule.style.color) {
                    activeColor = this.mx3ColorToCss(rule.style.color) || activeColor;
                  }
                }
              } catch (e) {
                // seletor inválido/incompatível com este elemento - ignora
              }
            }
          }
        }
      } catch (e) {
        // document.styleSheets indisponível por algum motivo - segue sem hover/ativo
      }
      // Leitura mais fiel do estado hover (gradientes, @media, !important e especificidade).
      let hoverGradient = null;
      try {
        const hv = this.mx3ResolveHoverStyle(el);
        if (hv.found) {
          hasHover = true;
          hoverBackground = hv.bg || hoverBackground;
          hoverColor = hv.color || hoverColor;
          hoverGradient = hv.grad;
        }
      } catch (e) { /* mantém a leitura simples */ }
      let normal = { bg: "", visibleBg: "", grad: null };
      try { normal = this.mx3ResolveNormalStyle(el); } catch (e) { /* ignora */ }
      return {
        currentGradient: normal.grad,
        currentBackgroundVisible: normal.visibleBg,
        hoverGradient,
        activeGradient,
        // Enviados apenas como REFERÊNCIA (placeholder) no Gerenciador -
        // não devem ser aplicados automaticamente como override, senão a
        // cor do elemento muda sozinha assim que ele é selecionado.
        currentBackground: this.mx3ColorToCss(cs.backgroundColor),
        currentColor: textClip ? "" : this.mx3ColorToCss(cs.color),
        textClip,
        hasBorder,
        hasHover,
        hoverBackground,
        hoverColor,
        hasActive,
        activeBackground,
        activeColor,
        activeClass,
      };
    },
    // Busca o carrinho salvo vinculado à conta do cliente logado e o
    // combina com o que já estiver no navegador (ex.: itens adicionados
    // como visitante antes de logar), dando sequência à lista até que o
    // pedido seja concluído. Roda só uma vez por login (flag
    // "carrinhoContaRestaurado") - depois disso o carrinho local já fica
    // sincronizado com o servidor a cada mudança (ver watch acima), então
    // buscar de novo a cada recarregamento de página duplicaria os itens.
    restaurarDesejosDaConta() {
      this.restaurandoDesejosDaConta = true;
      this.$api
        .httpService()
        .get(window.location.origin + "/api/wishlist_get.php")
        .then((res) => {
          const itens = Array.isArray(res?.data?.itens)
            ? res.data.itens.map((id) => String(id))
            : [];
          this.$store.state.desejos = itens;
        })
        .catch((err) => console.error("Erro ao restaurar lista de desejos da conta:", err))
        .finally(() => {
          this.restaurandoDesejosDaConta = false;
        });
    },
    salvarDesejosDaConta() {
      this.$api
        .httpService()
        .post(window.location.origin + "/api/wishlist_save.php", {
          itens: this.$store.state.desejos || [],
        })
        .catch((err) => console.error("Erro ao salvar lista de desejos da conta:", err));
    },
    restaurarCarrinhoDaConta() {
      this.$api
        .httpService()
        .get(window.location.origin + "/api/cart_get.php")
        .then((res) => {
          localStorage.setItem("carrinhoContaRestaurado", "sim");

          const itensDaConta = res?.data?.itens || [];
          if (!itensDaConta.length) return;

          const carrinhoAtual = this.$store.state.carrinho || [];
          this.$store.state.carrinho = [...carrinhoAtual, ...itensDaConta];
        })
        .catch((err) => console.error("Erro ao restaurar carrinho da conta:", err));
    },
    // Condições de venda da Precificação (Pix, parcelas, frete grátis, mais vendido...).
    carregarCondicoesVenda() {
      this.$api
        .getCondicoesVenda()
        .then((dados) => {
          if (dados) this.$store.state.condicoesVenda = dados;
        })
        .catch(() => {});
    },
    // Médias/quantidade de avaliações de todos os produtos (estrelas dos cards).
    carregarResumoAvaliacoes() {
      this.$api
        .getResumoAvaliacoes()
        .then((mapa) => {
          this.$store.state.avaliacoesResumo = mapa || {};
        })
        .catch(() => {});
    },
    loadConfiguracoesSite() {
      console.log("[DEBUG] Carregando configurações do site...");

      // Limpa o cache para forçar buscar dados atualizados
      localStorage.removeItem('configuracoes_publicas_cache');
      localStorage.removeItem('configuracoes_publicas_timestamp');

      // As configurações públicas do site (ex.: "ocultar preço para quem
      // não está logado") são hoje gerenciadas na tela "Configurações"
      // (aba "Exibição de Preços") do Gerenciador de Produtos, e não mais
      // no antigo backend Railway/Django - que foi desativado e não recebe
      // mais atualizações. Era por isso que alterar a opção no Gerenciador
      // não tinha nenhum efeito no e-commerce.
      //
      // getPublicApiConfig() já implementa o padrão correto usado pelo
      // restante do e-commerce: em produção busca diretamente (cross-domain,
      // com cache em memória) o config_api.php do Gerenciador, cuja URL é
      // resolvida dinamicamente (ver @/config/gerenciadorConfig.js); em
      // desenvolvimento local usa o proxy same-origin /api/config_api.php.
      getPublicApiConfig()
        .then((config) => {
          console.log("[DEBUG] Configurações públicas do Gerenciador:", config);

          const ocultarPrecoNaoLogado = !!config?.exibicao_precos?.ocultar_preco_nao_logado;

          console.log("[DEBUG] ocultar_preco_nao_logado:", ocultarPrecoNaoLogado);

          this.$store.state.configuracoesSite = {
            ...this.$store.state.configuracoesSite,
            ocultar_preco_nao_logado: ocultarPrecoNaoLogado,
          };

          // Salva no localStorage para persistência
          localStorage.setItem("configuracoesSite", JSON.stringify(this.$store.state.configuracoesSite));

          console.log("[DEBUG] Configurações salvas no store:", this.$store.state.configuracoesSite);
        })
        .catch((error) => {
          console.error("[DEBUG] Erro ao carregar configurações do site:", error);
        });
    }
  },
};
</script>

<style lang="scss">
#bg-video {
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -100;
  background-size: cover;
  object-fit: cover;
}

#app {
  font-family: "Roboto", "Montserrat", "Poppins", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

main {
  min-height: calc(100vh - 200px);
  margin: 0 !important;
  padding: 0 !important;
  width: 100% !important;
  overflow-x: hidden !important;
  /* clip não cria contêiner de rolagem (mantém position: sticky funcionando) */
  overflow-x: clip !important;
}

main > .col {
  margin: 0 !important;
  padding: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
}
.admin-section {
  background-color: transparent !important;
  margin-top: 5px !important;
  padding: 5px !important;

  color: black !important;

  * {
    color: black !important;
  }

  .text-small {
    font-size: 15px;
    color: #7c7c7c !important;
  }

  .text-white {
    color: white !important;

    path {
      fill: white !important;
    }
  }

  /* ---primary */
  .bg-primary {
    background-color: var(--primary) !important;
  }
  .bg-primary:focus {
    background-color: var(--primary) !important;
  }
  .bg-primary:hover {
    background-color: var(--primary) !important;
  }

  .btn-primary {
    background-color: var(--primary) !important;
    border: solid 0.1px #afafaf20 !important;
  }
  .btn-primary:focus {
    background-color: var(--primary) !important;
  }
  .btn-primary:hover {
    background-color: var(--primary) !important;
  }

  .btn-outline-primary {
    border-color: var(--primary) !important;
  }

  .btn-outline-primary:hover {
    background-color: var(--primary) !important;
  }

  .text-primary {
    color: var(--primary) !important;
  }
}
.pagination-- {
  .page-item {
    button {
      color: #afafaf !important;
    }
  }
}

.modal-content {
  background: var(--mx3-style-bg-card, #1c1e20) !important;
  background-color: var(--mx3-style-bg-card, #1c1e20) !important;
}

/* Alvos: Tablets, iPads e Smartphones deitados */
/* Exclui: Smartphones em pé (<481px) e Desktops/Laptops (>=1280px) */

@media only screen and (min-width: 481px) and (max-width: 1279px) {
  // @media only screen and (min-width: 481px) and (max-width: 1279px) {
  #header-main-
    > div
    > div
    > a.logo.d-flex.align-items-center
    > h1
    > div
    > img {
    width: 100px !important;
    margin-left: 25% !important;
  }
  header > .main-header {
    height: 60px !important;
  }

  .header-actions {
    scale: 1 !important;
    margin-right: unset !important;
  }
  #app
    > main
    > div
    > div
    > div
    > div:nth-child(1)
    > div.show-on-mobile.col
    > div
    > div
    > div.carousel-main-content {
    * {
      font-size: 1.2vh !important;
    }
    .product-badge {
      padding-top: 1px !important;
    }
  }

  #products-container-custom {
    max-width: 100% !important;
  }
  #produto-item- {
    min-width: 205px !important;
    .product-details{
      *{
        font-size:10px !important
      }
    }
  }
  #app
    > main
    > div
    > div
    > div
    > div:nth-child(2)
    > div.show-on-mobile.col
    > div {
    padding-right: 25px !important;
  }
}
/* Ajuste exclusivo para Smartphones Deitados (ex: iPhone 14 Pro Max) */
@media only screen and (min-width: 481px) and (max-width: 932px) and (max-height: 500px) {

  /* Seletor ultra específico baseado no seu XPath para forçar o badge */
  #app > main > div > div > div > div:nth-child(1) > div:nth-child(2) > div > div > div:nth-child(1) > div:nth-child(2) > div > span.product-badge,
  #app > main > div > div > div > div:nth-child(1) > div:nth-child(2) > div > div > div:nth-child(1) > div:nth-child(2) > div > span {
      padding-top: 5px !important;
  }

  /* Ajuste de fonte para o conteúdo */
  #app > main > div > div > div > div:nth-child(1) > div.show-on-mobile.col > div > div > div.carousel-main-content * {
      font-size: 2vh !important;
  }
}
/* Modo Edição (Personalizar): as etiquetas do card ficam clicáveis para serem ajustadas uma a uma. */
html.mx3-edit-active .produto-card-custom .mx3-card-badges {
  pointer-events: auto !important;
}
</style>
